module.exports = __webpack_public_path__ + "static/img/sdlyy.8fd2abe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/sdlyy.png
// module id = jV2h
// module chunks = 0